import FreespinRequestBuilder from "slotworks/integration/revolver/builders/requests/freespin-request-builder";
import PickRequestBuilder from "slotworks/integration/revolver/builders/requests/pick-request-builder";
import SpinRequestBuilder from "slotworks/integration/revolver/builders/requests/spin-request-builder";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import { PrecannedResultList } from "slotworks/server/precanned/precanned-result-list";
import Contract from "slotworks/utils/contract";
class RevolverPrecannedResults implements PrecannedResultList {

    public customStops: Map<string, string[][]> = new Map<string, string[][]>();

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            resolve(RevolverModel.getForceStrings());
        });
    }

    public force(id: string): Contract<void> {
        return new Contract<void>((resolve) => {
            if (this.customStops.has(id)) {
                SpinRequestBuilder.customStops = this.customStops.get(id);
            } else {
                SpinRequestBuilder.force = id;
                FreespinRequestBuilder.force = id;
                PickRequestBuilder.force = id;
            }
        });
    }
}

export default new RevolverPrecannedResults();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/precanned/revolver-precanned-results.ts